export const addType = ({ form }) => {
    form.setConfig({
        "title": "Add new Type",
        "type": "push",
        "location": "Matrices/SignatoryMatrix/Types",
        "fields": [{
            "label": "Type",
            "type": "text",
            "name": "Type"
        }, {
            "label": "Threshold",
            "type": "number",
            "name": "Threshold"
        }]
    });
    form.toggle();
};

export const editType = ({ form, rowItem }) => {
    form.setValues(rowItem);
    form.setConfig({
        "title": "Add new Type",
        "type": "update",
        "location": `Matrices/SignatoryMatrix/Types/${rowItem.ID}`,
        "fields": [{
            "label": "Type",
            "type": "text",
            "name": "Type"
        }, {
            "label": "Threshold",
            "type": "number",
            "name": "Threshold"
        }]
    });
    form.toggle();
};


export const deleteType = ({ form, rowItem }) => {
    form.setConfig({
        "title": "Delete Type",
        "type": "delete",
        "location": `Matrices/SignatoryMatrix/Types/${rowItem.ID}`,
        "fields": []
    });
    form.toggle();
};  
